<div class="container-login100 animated fadeIn" style="height: -webkit-fill-available;">

  <div class="wrap-login100 shadow" style="position: relative; width: 100%; height: -webkit-fill-available;">

    <div class="login100-form-title">
      <img src="../../../assets/imgs/logo-um.png" height="100" style="margin: 10px;">
    </div>

    <div class="col-sm-12" style="padding: 0 24px;">
      <br>
      <div style="display:flex; align-items:center; justify-content:space-between; flex-wrap:wrap; gap:10px;">
        <div>
          <h3 style="margin:0; color:#111827; font-size:20px; font-weight:700;">
            <i class="fa fa-graduation-cap" style="color:#0073b7; margin-right:8px;"></i>
            Tutoriais
          </h3>
          <p style="margin:4px 0 0; color:#6b7280; font-size:13px;">Apostilas de usabilidade do sistema</p>
        </div>
        <button class="btn btn-default btn-sm" [routerLink]="['/login']" style="display:flex; align-items:center; gap:6px;">
          <i class="fa fa-arrow-left"></i> Voltar para login
        </button>
      </div>
      <hr style="margin:16px 0;">
    </div>

    <div class="col-sm-12" style="padding: 0 24px 24px;">

      <div style="display:flex; flex-direction:column; gap:10px;">
        <div *ngFor="let item of conteudo; let i = index"
          style="display:flex; align-items:center; justify-content:space-between; padding:14px 16px; background:#f8fafc; border-radius:10px; border-left:4px solid #0073b7; gap:12px;">
          <div style="display:flex; align-items:center; gap:12px; flex:1; min-width:0;">
            <span style="background:#dbeafe; color:#0073b7; font-weight:700; font-size:12px; min-width:28px; height:28px; border-radius:50%; display:flex; align-items:center; justify-content:center; flex-shrink:0;">
              {{ i + 1 }}
            </span>
            <span style="color:#374151; font-size:14px; line-height:1.4;">{{ item.descricao }}</span>
          </div>
          <button (click)="visualizarVideo(item)"
            style="background:#16a34a; border:none; border-radius:8px; padding:8px 14px; cursor:pointer; display:flex; align-items:center; gap:6px; color:#fff; font-size:13px; font-weight:600; white-space:nowrap; flex-shrink:0;">
            <i class="fa fa-play" style="font-size:11px;"></i> Assistir
          </button>
        </div>
      </div>

      <div *ngIf="conteudo.length === 0"
        style="text-align:center; padding:48px 24px; color:#9ca3af;">
        <i class="fa fa-inbox" style="font-size:40px; margin-bottom:12px; display:block;"></i>
        <p style="margin:0; font-size:14px;">Nenhum tutorial disponível no momento.</p>
      </div>

    </div>

    <div class="col-sm-12">
      <hr>
      <p class="text-center" style="margin-bottom: 15px; color: #ccc;">by nflsoftware.com</p>
    </div>

  </div>

</div>


<p-dialog
  header="Visualizar tutorial"
  [(visible)]="mostraVideo"
  [style]="{width: '860px'}"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeModalVideo()">

  <div style="padding:4px 0;">
    <video
      controls
      controlsList="nodownload"
      loop
      width="100%"
      style="border-radius:8px; background:#000;"
      [src]="caminhoVideo"
      type="video/mp4">
    </video>
  </div>

</p-dialog>
